import React from "react";
import VirtualAssistantController from './HatManagementComponents/VirtualAssistantController';

interface HatManagementProps {
  onClose?: () => void;
}

const HatManagement: React.FC<HatManagementProps> = ({ onClose }) => {
  return (
    <div className="mx-auto w-full max-w-screen-lg divide-y divide-gray-200 rounded-xl bg-white p-2">
      <VirtualAssistantController onClose={onClose} />
    </div>
  );
};

export default HatManagement;